import { useCallback, useEffect, useState } from 'react';
import { api, ApiError, type Me } from '@/lib/api';

type State =
  | { status: 'loading' }
  | { status: 'authed'; me: Me }
  | { status: 'anon' };

export function useAuth() {
  const [state, setState] = useState<State>({ status: 'loading' });

  const refresh = useCallback(async () => {
    try {
      const me = await api.get<Me>('/api/auth/me');
      setState({ status: 'authed', me });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setState({ status: 'anon' });
      } else {
        setState({ status: 'anon' });
      }
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(
    async (pin: string) => {
      await api.post('/api/auth/login', { pin });
      await refresh();
    },
    [refresh],
  );

  const logout = useCallback(async () => {
    await api.post('/api/auth/logout');
    setState({ status: 'anon' });
  }, []);

  return { state, login, logout, refresh };
}
